import { render, staticRenderFns } from "./shift-statistics.vue?vue&type=template&id=20392ce3&scoped=true"
import script from "./shift-statistics.vue?vue&type=script&lang=js"
export * from "./shift-statistics.vue?vue&type=script&lang=js"
import style0 from "./shift-statistics.vue?vue&type=style&index=0&id=20392ce3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20392ce3",
  null
  
)

export default component.exports